import { useState, useMemo } from 'react';
import Moment from 'moment';
import { DiscountAndCount } from '../../models/APIModels';

export type FilterStatus = 'all' | 'active' | 'inactive';

export function useDiscountFilters(discounts: DiscountAndCount[]) {
  const [filterStatus, setFilterStatus] = useState<FilterStatus>('all');
  const [filterUpFront, setFilterUpFront] = useState(false);
  const [filterRecurring, setFilterRecurring] = useState(false);

  const filteredDiscounts = useMemo(() => {
    return discounts.filter((d) => {
      // 1. Status Filter
      if (filterStatus !== 'all') {
        const currentDate = Moment();
        const expireDateIsBeforeCurrent = Moment(d.expires).isBefore(currentDate);
        const isActive = !(d.expires && expireDateIsBeforeCurrent);
        
        if (filterStatus === 'active' && !isActive) return false;
        if (filterStatus === 'inactive' && isActive) return false;
      }

      // 2. Up-Front Filter
      if (filterUpFront && !d.upFront) {
        return false;
      }

      // 3. Recurring Filter
      if (filterRecurring && !d.recurring) {
        return false;
      }

      return true;
    });
  }, [discounts, filterStatus, filterUpFront, filterRecurring]);

  return {
    filterStatus,
    setFilterStatus,
    filterUpFront,
    setFilterUpFront,
    filterRecurring,
    setFilterRecurring,
    filteredDiscounts,
  };
}
